module.exports = __webpack_public_path__ + "public/img/shengjiangji.bf354062.png";